module.exports = __webpack_public_path__ + "static/laptop-resan-bec979545756f52316f151a18b29985a.png";